var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.signState)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.saveURLandAuth}},[_vm._v("Log In")]):_c('a',{attrs:{"href":"#"},on:{"click":_vm.logout}},[_vm._v("Log Out")])}
var staticRenderFns = []

export { render, staticRenderFns }